
export function getTimerStarted(state) {
    return state['features/base/conference'].timerStarted;
}
